import { useTheme } from '../contexts/ThemeContext'
import { ROTHKO_MODULES } from '../config/themes'

export default function MotherwellBg() {
  const { theme, module } = useTheme()
  if (theme !== 'rothko') return null

  const r = ROTHKO_MODULES[module] || ROTHKO_MODULES.default

  return (
    <svg
      aria-hidden="true"
      className="absolute inset-0 w-full h-full pointer-events-none z-0"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 380 260"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transition: '1.4s ease' }}
    >
      <defs>
        {/* Heavy blur for Motherwell blobs — creates the soft diffused perimeter look */}
        <filter id="mw-blob" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="22" />
        </filter>
        {/* Lighter blur for vertical bars — softens edges while preserving bar shape */}
        <filter id="mw-bar" x="-40%" y="-10%" width="180%" height="120%">
          <feGaussianBlur stdDeviation="7" />
        </filter>
        {/* Radial vignette: warm accent glows inward from all four perimeter edges */}
        <radialGradient id="mw-vignette" cx="50%" cy="50%" r="70%"
          gradientUnits="userSpaceOnUse" fx="190" fy="130">
          <stop offset="20%" stopColor={r.perimeterColor || r.accent} stopOpacity="0" />
          <stop offset="100%" stopColor={r.perimeterColor || r.accent} stopOpacity="0.30" />
        </radialGradient>
      </defs>

      {/* Motherwell forms — blobs with diffused edges, bars with soft glow */}
      {(r.forms || []).map((form, i) => {
        const fill = form.color || '#1A0804'
        const opacity = form.opacity ?? 0.40
        const filter = form.sharp ? 'url(#mw-bar)' : 'url(#mw-blob)'

        if (form.type === 'ellipse') {
          return (
            <ellipse
              key={i}
              cx={form.cx} cy={form.cy}
              rx={form.rx} ry={form.ry}
              fill={fill} opacity={opacity}
              filter={filter}
            />
          )
        }
        if (form.type === 'rect') {
          return (
            <rect
              key={i}
              x={form.x} y={form.y}
              width={form.w} height={form.h}
              fill={fill} opacity={opacity}
              filter={filter}
            />
          )
        }
        return null
      })}

      {/* Perimeter diffusion vignette */}
      <rect x="0" y="0" width="380" height="260" fill="url(#mw-vignette)" />
    </svg>
  )
}
